<div class="errwrap">
  <div class="errdiv1" id="errs">

  </div>
</div>

<div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">

      <h1 class="screen-title">{{screentitle}}</h1>

      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="btn back-button button-margin ">
          <button [disabled]="RAC_APROVE!=1" class="approved"
            *ngIf="isApproved   && actionmode =='Edit'  && rejected!=2">

            <span class="bold">Approved</span>
          </button>
          <input type="button" [disabled]="RAC_APROVE!=1" class="btn btn-success commonbutt"
            style="width: 80px;font-weight: 700" value="Active" id="btnname" (click)="changeName()"
            *ngIf="isApproved  && actionmode =='Edit'  && rejected!=2  ">
          <button [disabled]="nameExist|| showList==true || viewpage==true || invalidCityName || onlyspclchar || onlynum || exceedLength || notAlphabet || minlength || cnameExceed || mincityname || onlynumc 
              || bannerCodeNotAlphaNumeric || bannerCodeMinLength" class="btn btn-primary commonbutt" type="button"
            (click)="submitData1()">
            <em class="fa fa-check"></em>&nbsp;Submit </button>

          <button class="btn btn-success commonbutt" type="button"
            *ngIf="    !isApproved && updateApprove && RAC_APROVE =='1'" data-toggle="modal" data-target="#myModal">
            <em class="fa fa-thumbs-up "></em>&nbsp;&nbsp;
            <span class="bold">Approve</span>
          </button>
          <button class="btn btn-warning commonbutt" type="button"
            *ngIf="   !isApproved &&      updateApprove && RAC_APROVE =='1'" data-toggle="modal"
            data-target="#myModal2">
            <em class="fa fa-thumbs-down"></em>
            <span class="bold">Reject</span>
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>

        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="errdiv1">
                        <p class="text-danger" style="text-align: center" id="err"></p>

                      </div>
                      <div class="col-lg-3">
                        <label>Banner Type</label>
                        <select class="form-control" [(ngModel)]="screen_details.BANNER_TYPE"
                          (change)="gotochangestatus(1)" (input)="checkEdit()">
                          <option value="">--Select Banner Page--</option>
                          <option *ngFor="let banner of bannerType" value={{banner.key}}>
                            {{banner.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Display Page</label>
                        <select class="form-control" [(ngModel)]="screen_details.BANNER_PAGE"
                          (change)="gotochangestatus(1)" (input)="checkEdit()">
                          <option value="">--Select Banner Page--</option>
                          <option *ngFor="let bannerPage of bannerPages" value={{bannerPage}}>
                            {{bannerPage}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Banner Name</label>
                        <select class="form-control" [disabled]="actionmode =='Edit'"
                          [(ngModel)]="screen_details.PAGE_SECTION" (change)="gotochangestatus(2)"
                          (input)="checkEdit()">
                          <option value="">--Select Banner Name --</option>
                          <option *ngFor="let pageSection of pageSections" value={{pageSection[PAGE_SECTION]}}>
                            {{pageSection['PAGE_SECTION']}}
                          </option>
                        </select>
                        <span *ngIf="nameExist" style="color: red">Banner Name already exist</span>
                      </div>

                      <div class="col-lg-3">
                        <label>Platform</label>
                        <select class="form-control" [(ngModel)]="screen_details.PLATFORM">
                          <option value="">--Select Platform --</option>
                          <option>Web</option>
                          <option>Mobile</option>
                        </select>
                      </div>

                      <div class="clr"></div>

                      <div class="col-lg-3" *ngIf="isBannerImage == true && screen_details.BANNER_PAGE !='Texts'">

                        <label *ngIf="isSearchWidget == true" class="">Guest Banner</label>
                        <label *ngIf="isSearchWidget == false" class="">Banner</label>
                        <input type="file" name="photo" [disabled]="showList==true" (input)="checkEdit()"
                          (change)="getFileDetails($event,'not-login')" ng2FileSelect [uploader]="uploader"
                          class="form-control">
                      </div>
                      <div *ngIf="BANNER_IMG != '' && isBannerImage == true && screen_details.BANNER_PAGE !='Texts'">
                        <img [src]="getImage(BANNER_IMG)" width="100px" height="95px" alt="Banner Image">
                      </div>

                      <div class="clr"></div>
                      <div class="divider">
                      </div>



                      <div class="col-lg-12">
                        <div class="col-lg-6">
                          <label *ngIf="isSearchWidget == true" class="">Guest Banner Heading</label>
                          <label *ngIf="isSearchWidget == false" class="">Banner Heading</label>
                          <app-tiny-editor [elementId]="'my-editor1'" (onEditorContentChange)="keyupHandler1($event)"
                            [editedData]="editedData1">
                          </app-tiny-editor>
                        </div>


                      </div>

                      <div class="col-lg-12" style="margin-top: 28px">
                        <div class="col-lg-6">
                          <label *ngIf="isSearchWidget == true" class="">Guest Banner Description</label>
                          <label *ngIf="isSearchWidget == false" class="">Banner Description</label>
                          <app-tiny-editor [elementId]="'my-editor'" (onEditorContentChange)="keyupHandler($event)"
                            [editedData]="editedData">
                          </app-tiny-editor>
                        </div>
                      </div>
                      <ng-container *ngIf="isSearchWidget == true">
                        <div class="clr"></div>
                        <div class="divider">
                        </div>
                        <div class="col-lg-3" *ngIf="isBannerImage == true && screen_details.BANNER_PAGE !='Texts'">
                          <label class="">Member Banner </label>
                          <input type="file" name="photo" [disabled]="showList==true" (input)="checkEdit()"
                            (change)="getFileDetails($event,'login')" ng2FileSelect [uploader]="uploader"
                            class="form-control">
                        </div>
                        <div
                          *ngIf="LOGIN_BANNER_IMG != '' && isBannerImage == true && screen_details.BANNER_PAGE !='Texts'">
                          <img [src]="getImage(LOGIN_BANNER_IMG)" width="100px" height="95px" alt="Banner Image">
                        </div>
                        <div class="clr"></div>
                        <div class="divider">
                        </div>
                        <div class="col-lg-6">
                          <label class="">Member Banner Description</label>
                          <app-tiny-editor-login [loginelementId]="'my-mem'"
                            (onEditorContentChange)="loginkeyupHandler($event)" [logineditedData]="logineditedData">
                          </app-tiny-editor-login>
                        </div>
                      </ng-container>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" (click)="clearRemark()" class="close" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-up" style="margin-right: 10px"></span>Do you want to approve ?
        </h4>
      </div>

      <div class="modal-body">
        <div class="col-lg-13">
          <label> Remarks</label>
          <textarea 
          [(ngModel)]="aprove_details.APPROVAL_REMARKS" 
          (input)="getremark($event.target.value);"
            (blur)="checkRemarkLength($event.target.value)" 
            rows="8" cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
        </textarea>
          <span *ngIf="minRemark" 
          class="m-form__help" style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="!aprvbtn" 
        class="btn btn-success " type="button" 
        (click)="aproveReject(1)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>

        <button 
        class="btn btn-warning " 
        (click)="clearRemark()" type="button" data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="myModal2" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header" style="padding:20px 31px;">
        <button type="button" 
        class="close" 
        (click)="clearRemark()" data-dismiss="modal">
          &times;
        </button>
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-thumbs-down" style="margin-right: 10px"></span>Do you want to reject ?
        </h4>
      </div>
      <div class="modal-body">
        <div class="col-lg-13">
          <label>Remarks</label>
          <textarea [(ngModel)]="aprove_details.APPROVAL_REMARKS" rows="8" (input)="getremark($event.target.value);"
            (blur)="checkRemarkLength($event.target.value)" cols="20" type="text" class="form-control m-input"
            placeholder="Enter  Remarks">
        </textarea>
          <span *ngIf="minRemark" class="m-form__help" style="color: red">Please enter Remarks with minimum length
            3</span>
        </div>
      </div>
      <div class="modal-footer">
        <button [disabled]="!aprvbtn" class="btn btn-success" type="button" (click)="aproveReject(2)"
          data-dismiss="modal">
          <span class="bold">Yes</span>
        </button>
        <button class="btn btn-warning " (click)="clearRemark()" type="button" data-dismiss="modal">
          <span class="bold">No</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode!='Add' && actionmode!='Edit' && actionmode!='View'" class="searchdiv">
  <div>
    <div class="headerdiv">
      <h1>
        Banner Search
      </h1>
      <div class="bothbuttdiv">
        <button class="btn btn-primary commonbutt" *ngIf="RAC_ADD =='1'" type="button" (click)="addForm()">
          <em class="fa fa-plus-circle"></em>&nbsp;Add New</button>

      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div class="wr15">


                      <div class="instruct">
                        <div class="int1" style="margin-left: 17px">
                          <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                          <br />


                          <span class="txt">
                            1. Select at least one value out of Display Page,Banner Name.

                          </span>
                          <br />
                          <span class="txt">
                            2. You can also use a combination of the given fields to search </span>
                          <br />
                          <span></span>
                        </div>
                      </div>

                      <div class="col-lg-3">
                        <label>Display Page</label>
                        <select class="form-control" [(ngModel)]="search_details.BANNER_PAGE">
                          <option value="">--Select Banner Page--</option>
                          <option *ngFor="let bannerPage of bannerPages" value={{bannerPage}}>
                            {{bannerPage}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Banner Name</label>
                        <select class="form-control" [(ngModel)]="search_details.PAGE_SECTION">
                          <option value="">--Select Banner Name--</option>
                          <option *ngFor="let pageSection of pageSections" value={{pageSection[PAGE_SECTION]}}>
                            {{pageSection[['PAGE_SECTION']]}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="btn clear-button button-margin">
                    <button class="btn btn-primary commonbutt" (click)="searchData()" type="button">
                      <em class="fa fa-search "></em>&nbsp;Search</button>
                  </div>
                </div>
                <div class="errwrap">
                  <div class="errdiv1" id="err">

                  </div>
                </div>
                <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                  <table aria-describedby="bannerDetails" class="table table-striped" *ngIf="!loader"
                    [mfData]="serachtabledata" [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 20%" *ngIf="RAC_VIEW =='1' || RAC_EDIT =='1'">
                          Actions
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="REGION_CODE">Display Page
                          </mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="REGION_NAME">Banner Name
                          </mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="REGION_NAME">Banner Type
                          </mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="PLATFORM">Platform</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter>Status</mfDefaultSorter>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of serachtabledata | paginate: { itemsPerPage: 10, currentPage: p }">
                        <td *ngIf="RAC_VIEW =='1' || RAC_EDIT =='1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW =='1'" type="button"
                            (click)="showFormData(item.BANNER_ID,1,1,1)">
                            <em class="fa fa-eye"></em>
                          </button>
                          <span *ngIf="item.STATUS!='2' && item.PRE_APPROVE!='1'">
                            <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT =='1'" type="button"
                              (click)="showFormData(item.BANNER_ID,2,item.STATUS,item.APPROVAL_STATUS)">
                              <em class="fa fa-pencil"></em>
                            </button>
                          </span>
                        </td>
                        <td>{{item.BANNER_PAGE| uppercase}}</td>
                        <td>{{item.PAGE_SECTION}}</td>
                        <td>
                          <ng-container *ngIf="item.BANNER_CODE == 'R'">Redeem</ng-container>
                          <ng-container *ngIf="item.BANNER_CODE == 'A'">Accrual</ng-container>
                        </td>
                        <td>{{item.PLATFORM}}</td>

                        <td>


                          <div *ngIf="
                            item.APPROVAL_STATUS == 0 &&
                            item.STATUS == 0 &&
                            item.PRE_APPROVE != 1
                          ">
                            <span class="icls1">
                              <button class="btn commonbutt zol1">
                                Inactive
                              </button>

                              <span class="tooltiptext">Not Approved</span>
                            </span>
                          </div>

                          <div *ngIf="
                            item.APPROVAL_STATUS == 1 && item.PRE_APPROVE != 1
                          ">
                            <span class="icls1">
                              <button class="btn  commonbutt zol" *ngIf="item.STATUS == 1">
                                Active
                              </button>

                              <button class="btn  commonbutt zol1" *ngIf="item.STATUS == 0">
                                Inactive
                              </button>

                              <span class="tooltiptext"> Approved </span>
                            </span>
                          </div>








                          <div *ngIf="
                          item.APPROVAL_STATUS == 0 && item.PRE_APPROVE == 1
                        ">
                            <span class="icls1">
                              <button class="btn  commonbutt zol">
                                Active
                              </button>



                              <span class="tooltiptext"> Approved </span>
                            </span>
                          </div>


                          <div *ngIf="item.APPROVAL_STATUS == 2 && item.STATUS == 2">
                            <span class="icls5">
                              <button class="btn  commonbutt zol1">
                                Inactive
                              </button>

                              <span class="tooltiptext">Rejected</span>
                            </span>
                          </div>

                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="4">
                          <pagination-controls (pageChange)="p = $event"></pagination-controls>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div *ngIf="loader">
                  <div style="margin:auto; text-align: center">
                    <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div *ngIf="actionmode=='View'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" *ngIf="showList==!false">{{viewTitle}}</h1>
      <h1 class="screen-title" *ngIf="showList==false">{{insertDataTitle}}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode=='View'" class="btn back-button button-margin ">
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>

                      <div class="tdive">
                        <table aria-describedby="searchBannerDetails" class="viewtable">
                          <div *ngFor="let q of serachTableInfo">

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Display Page:</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.BANNER_PAGE }}</span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span class="vlbl">Banner Name</span>
                              </th>
                              <td>

                                <span class="vVal">{{ q.PAGE_SECTION }}</span>

                              </td>
                            </tr>
                            <tr>
                              <th scope="col" *ngIf="BANNER_IMG != ''">
                                <span *ngIf="isSearchWidget == true" class="vlbl">Guest Banner</span>
                                <span *ngIf="isSearchWidget == false" class="vlbl">Banner</span>
                              </th>
                              <td>
                                <div *ngIf="BANNER_IMG != ''">
                                  <img [src]="getImage(BANNER_IMG)" width="100px" height="95px" alt="Loader">
                                </div>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span *ngIf="isSearchWidget == true" class="vlbl">Guest Banner Description</span>
                                <span *ngIf="isSearchWidget == false" class="vlbl">Banner Description</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ q.BANNER_TEXT }} </span>
                              </td>
                            </tr>


                            <tr>
                              <th scope="col">
                                <span *ngIf="isSearchWidget == true" class="vlbl">Guest Banner Heading</span>
                                <span *ngIf="isSearchWidget == false" class="vlbl">Banner Heading</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ q.BANNER_HEADER }} </span>
                              </td>
                            </tr>

                            <tr>
                              <th scope="col">
                                <span *ngIf="isSearchWidget == true" class="vlbl">Guest Platform</span>
                                <span *ngIf="isSearchWidget == false" class="vlbl">Platform</span>
                              </th>
                              <td>
                                <span class="vVal"> {{ q.PLATFORM }} </span>
                              </td>
                            </tr>

                            <ng-container *ngIf="isSearchWidget == true">
                              <tr>
                                <th scope="col" *ngIf="LOGIN_BANNER_IMG != ''">
                                  <span class="vlbl">Member Banner</span>
                                </th>
                                <td>
                                  <div *ngIf="LOGIN_BANNER_IMG != ''">
                                    <img [src]="getImage(LOGIN_BANNER_IMG)" width="100px" height="95px" alt="Loader">
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <th scope="col">
                                  <span class="vlbl">Member Banner Description</span>
                                </th>
                                <td>
                                  <span class="vVal"> {{ q.LOGIN_BANNER_TEXT }} </span>
                                </td>
                              </tr>
                            </ng-container>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>